import { EmailTheme } from "../types/EmailTheme";

// todo: pull from shared mui theme (cross-repo import dep was causing issues, so this was a workaround)
export const emailTheme: EmailTheme = {
  titleStyles: {
    fontSize: "1rem",
    fontWeight: "400",
    fontFamily: "'Figtree', 'Helvetica', 'Arial', sans-serif",
    color: "#0066A1",
  },
  colors: {
    solutions: "#16AAFF",
    target: "#69B958",
    remainingEmissions: "#CFD8DC",
    baseline: "#0066A1",
    businessGrowth: "#0066A1",
    cleanerGrid: "#0066A1",
    gap: "#FF9800",
    costScoreLow: "#2E7D32",
    costScoreMedium: "#EF6C00",
    costScoreHigh: "#D32F2F",
    costScoreInactive: "#BDBDBD",
  },
};
